<template>
  <section class="inner">
    <nav class="breadcrumb is-small has-dot-separator">
      <ul>
        <li>
          <b-icon icon="home" size="is-small" />
        </li>
        <li v-if="portefeuille" class="is-active">
          <a href="#">
            {{ portefeuille.name }}
          </a>
        </li>
      </ul>
    </nav>

    <b-tabs v-model="activeTab" :animated="false">
      <b-tab-item>
        <template slot="header">
          <b-icon icon="folder" size="is-small" />
          {{$t('p-home.title-doc')}}
        </template>
        <div class="content has-text-grey has-text-centered">
          <p>{{$t('p-home.message1')}}</p>
        </div>
      </b-tab-item>

      <!-- Règle métier : visible si les CGA sont acceptées, ou s'il n'y a pas de
           CGA obligatoires (getter cgaOk). L'ancien « iscgavisible » testait le
           mauvais drapeau (isMandatory) : l'onglet était masqué sans CGA et
           visible avec des CGA non acceptées. -->
      <b-tab-item :visible="allowQuestions && cgaOk">
        <template slot="header">
          <b-icon icon="question-circle" size="is-small" />
          {{$t('p-home.title-question')}}
        </template>
        <PortefeuilleQuestions
          v-if="this.$route.params.portefeuille"
          ref="question"
          :test="true"
          :includePortefeuilleData="true"
        />
        <div v-else class="content has-text-grey has-text-centered">
          <p>{{$t('p-home.message2')}}</p>
        </div>
      </b-tab-item>

      <b-tab-item :visible="cgaOk">
        <template slot="header">
          <b-icon icon="envelope" size="is-small" pack="far" />
          {{$t('p-home.title-notif')}}
        </template>
        <div class="content has-text-grey has-text-centered">
          <p>{{$t('p-home.message3')}}</p>
        </div>
      </b-tab-item>

      <b-tab-item  v-if="this.iscgavisible">
        <template slot="header">
          <b-icon icon="file-earmark-text-fill" size="is-small" pack="far" />
          {{$t('p-home.title-cgu')}}
        </template>
        <div class="content has-text-grey has-text-centered">
          <CGA :documentUrl="pdfUrl" :portefeuille-id="$route.params.portefeuille" ref="cga" />
        </div>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PortefeuilleQuestions from '@/components/Portefeuille/Questions'
import CGA from '@/components/Portefeuille/CGA.vue'

export default {
  name: 'Home',
  components: {
    PortefeuilleQuestions,
    CGA,
  },
  created () {
    this.fetchCgaData()
  },
  data () {
    let activeTab = 0
    return {
      activeTab,
      iscgavisible: null,
      cgadata: null,
      pdfUrl: null,
    }
  },
  computed: {
    ...mapGetters({
      allowQuestions: 'inv/allowQuestions',
    }),
    ...mapState({
      user: state => state.user,
      biens: (state) => state.inv.biens,
    }),
    portefeuille () {
      if (!this.$route.params.portefeuille) return
      const value = this.biens.find(
        (i) => i.portefeuille === +this.$route.params.portefeuille
      )
      return value
        ? {
          id: value.portefeuille,
          name: value.portefeuilleName,
        }
        : null
    },
    // CGA acceptées, ou pas de CGA obligatoires — conditionne les onglets
    // Questions et Notifications. Se met à jour dès l'acceptation (setCgaValue
    // répercute dans le store).
    cgaOk () {
      return this.$store.getters.cgaOk(this.$route.params.portefeuille)
    },
  },
  watch: {
    '$route.params.portefeuille': 'fetchCgaData',
    portefeuille () {
      this.$store.commit(
        'inv/PORTEFEUILLE_SETTINGS',
        this.$route.params.portefeuille
      )
    },
  },
  methods: {
    getuser () {

    },
    // use to check if CGA is valid or not and display question or not
    async fetchCgaData () {
      if (this.$route.params.portefeuille) {
        const id = this.$route.params.portefeuille

        try {
          const data = await this.$store.dispatch('getCgaValue', { user: this.user.name, id })

          // get CGA from M-Files
          this.cgadata = data
          this.iscgavisible = data.isMandatory

          if (!data.isMandatory) {
            return
          }

          // L'onglet est deja affiche et montre son message d'attente. Le composant
          // reagit a l'arrivee du contenu par un watcher, plus besoin de l'ouvrir
          // explicitement via $refs — ce qui evitait de surcroit un appel sur une
          // reference pas encore montee.
          this.pdfUrl = null
          this.pdfUrl = await this.$store.dispatch('getCgaDocument', { user: this.user.name, id })
        } catch (error) {
          console.error(
            'Erreur lors de la récupération de la valeur CGA:',
            error
          )
        }
      } else {
        // Remettre la valeur de cga à null si $route.params.portefeuille n'est pas défini
        this.iscgavisible = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.inner {
  padding: 1em 1em;
}
.b-tabs {
  background: #fff;
}
</style>
